import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconAlarm = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0938 11.7188C12.75 10.7812 13.125 9.65625 13.125 8.4375C13.125 5.34375 10.5938 2.8125 7.5 2.8125C4.40625 2.8125 1.875 5.34375 1.875 8.4375C1.875 9.65625 2.25 10.7812 2.90625 11.7188L1.21875 13.4062C0.84375 13.7812 0.84375 14.3438 1.21875 14.7188C1.40625 14.9062 1.59375 15 1.875 15C2.15625 15 2.34375 14.9062 2.53125 14.7188L4.21875 13.0312C5.15625 13.6875 6.28125 14.0625 7.5 14.0625C8.71875 14.0625 9.84375 13.6875 10.7812 13.0312L12.4688 14.7188C12.6562 14.9062 12.9375 15 13.125 15C13.3125 15 13.5938 14.9062 13.7812 14.7188C14.1562 14.3438 14.1562 13.7812 13.7812 13.4062L12.0938 11.7188ZM6.5625 9.375V5.625H8.4375V7.5H10.3125V9.375H6.5625Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7813 0C9.75 0 8.8125 0.375 8.15625 0.9375C11.1562 1.21875 13.6875 3.1875 14.625 6C14.8125 5.4375 15 4.875 15 4.21875C15 1.875 13.125 0 10.7813 0Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.84375 0.9375C6.1875 0.375 5.25 0 4.21875 0C1.875 0 0 1.875 0 4.21875C0 4.875 0.1875 5.4375 0.375 6C1.40625 3.28125 3.84375 1.21875 6.84375 0.9375Z",
			fill: "currentColor"
		})
	]
});
export default SvgIconAlarm;
